export * from './assertions';
export * from './bindingPlaceholders';
export * from './carrierTransportationCostModuleEvidenceContract';
export * from './churnReductionModuleEvidenceContract';
export * from './commercialEffectivenessModuleEvidenceContract';
export * from './contextKinds';
export * from './costToServeModuleEvidenceContract';
export * from './esgEmissionsModuleEvidenceContract';
export * from './leverSnapshotModuleEvidenceContracts';
export * from './evidenceKeys';
export * from './financeModuleEvidenceContract';
export * from './laborArbitrageModuleEvidenceContract';
export * from './maFusionSynergyModuleEvidenceContract';
export * from './moduleEvidenceContract';
export * from './orgAnalysisOptimizationModuleEvidenceContract';
export * from './orgPatternCostModuleEvidenceContract';
export * from './outsideContractorsModuleEvidenceContract';
export * from './portfolioCapacityAllocationModuleEvidenceContract';
export * from './pricingRealizationModuleEvidenceContract';
export * from './productivityLeanAiModuleEvidenceContract';
export * from './professionalFeesModuleEvidenceContract';
export * from './realEstateFootprintModuleEvidenceContract';
export * from './referenceMechanisms';
export * from './riskClaimsModuleEvidenceContract';
export * from './schemaVersions';
export * from './segmentMarginCleanupModuleEvidenceContract';
export * from './sgaSpendModuleEvidenceContract';
export * from './sharedServicesModuleEvidenceContract';
export * from './sourceClasses';
export * from './stateKeys';
export * from './strategicExecutionCapacityModuleEvidenceContract';
export * from './techSoftwareModuleEvidenceContract';
export * from './workforceReductionModuleEvidenceContract';

import type { ModuleEvidenceContract } from './moduleEvidenceContract';
import { CARRIER_TRANSPORTATION_COST_MODULE_EVIDENCE_CONTRACT } from './carrierTransportationCostModuleEvidenceContract';
import { CHURN_REDUCTION_MODULE_EVIDENCE_CONTRACT } from './churnReductionModuleEvidenceContract';
import { COMMERCIAL_EFFECTIVENESS_MODULE_EVIDENCE_CONTRACT } from './commercialEffectivenessModuleEvidenceContract';
import { COST_TO_SERVE_MODULE_EVIDENCE_CONTRACT } from './costToServeModuleEvidenceContract';
import { ESG_EMISSIONS_MODULE_EVIDENCE_CONTRACT } from './esgEmissionsModuleEvidenceContract';
import {
  CAPACITY_UTILIZATION_MODULE_EVIDENCE_CONTRACT,
  FUEL_EFFICIENCY_MODULE_EVIDENCE_CONTRACT,
  MARKETING_SPEND_MODULE_EVIDENCE_CONTRACT,
  NETWORK_OPTIMIZATION_MODULE_EVIDENCE_CONTRACT,
} from './leverSnapshotModuleEvidenceContracts';
import { FINANCE_MODULE_EVIDENCE_CONTRACT } from './financeModuleEvidenceContract';
import { LABOR_ARBITRAGE_MODULE_EVIDENCE_CONTRACT } from './laborArbitrageModuleEvidenceContract';
import { ORG_ANALYSIS_OPTIMIZATION_MODULE_EVIDENCE_CONTRACT } from './orgAnalysisOptimizationModuleEvidenceContract';
import { ORG_PATTERN_COST_MODULE_EVIDENCE_CONTRACT } from './orgPatternCostModuleEvidenceContract';
import { OUTSIDE_CONTRACTORS_MODULE_EVIDENCE_CONTRACT } from './outsideContractorsModuleEvidenceContract';
import { PORTFOLIO_CAPACITY_ALLOCATION_MODULE_EVIDENCE_CONTRACT } from './portfolioCapacityAllocationModuleEvidenceContract';
import { PRICING_REALIZATION_MODULE_EVIDENCE_CONTRACT } from './pricingRealizationModuleEvidenceContract';
import { PRODUCTIVITY_LEAN_AI_MODULE_EVIDENCE_CONTRACT } from './productivityLeanAiModuleEvidenceContract';
import { PROFESSIONAL_FEES_MODULE_EVIDENCE_CONTRACT } from './professionalFeesModuleEvidenceContract';
import { REAL_ESTATE_FOOTPRINT_MODULE_EVIDENCE_CONTRACT } from './realEstateFootprintModuleEvidenceContract';
import { RISK_CLAIMS_MODULE_EVIDENCE_CONTRACT } from './riskClaimsModuleEvidenceContract';
import { SEGMENT_MARGIN_CLEANUP_MODULE_EVIDENCE_CONTRACT } from './segmentMarginCleanupModuleEvidenceContract';
import { SGA_SPEND_MODULE_EVIDENCE_CONTRACT } from './sgaSpendModuleEvidenceContract';
import { SHARED_SERVICES_MODULE_EVIDENCE_CONTRACT } from './sharedServicesModuleEvidenceContract';
import { STRATEGIC_EXECUTION_CAPACITY_MODULE_EVIDENCE_CONTRACT } from './strategicExecutionCapacityModuleEvidenceContract';
import { TECH_SOFTWARE_MODULE_EVIDENCE_CONTRACT } from './techSoftwareModuleEvidenceContract';
import { MA_FUSION_SYNERGY_MODULE_EVIDENCE_CONTRACT } from './maFusionSynergyModuleEvidenceContract';
import { WORKFORCE_REDUCTION_MODULE_EVIDENCE_CONTRACT } from './workforceReductionModuleEvidenceContract';

const moduleEvidenceContractRegistryEntries = {
  [SGA_SPEND_MODULE_EVIDENCE_CONTRACT.moduleId]: SGA_SPEND_MODULE_EVIDENCE_CONTRACT,
  [PROFESSIONAL_FEES_MODULE_EVIDENCE_CONTRACT.moduleId]:
    PROFESSIONAL_FEES_MODULE_EVIDENCE_CONTRACT,
  [TECH_SOFTWARE_MODULE_EVIDENCE_CONTRACT.moduleId]:
    TECH_SOFTWARE_MODULE_EVIDENCE_CONTRACT,
  [REAL_ESTATE_FOOTPRINT_MODULE_EVIDENCE_CONTRACT.moduleId]:
    REAL_ESTATE_FOOTPRINT_MODULE_EVIDENCE_CONTRACT,
  [SHARED_SERVICES_MODULE_EVIDENCE_CONTRACT.moduleId]:
    SHARED_SERVICES_MODULE_EVIDENCE_CONTRACT,
  [STRATEGIC_EXECUTION_CAPACITY_MODULE_EVIDENCE_CONTRACT.moduleId]:
    STRATEGIC_EXECUTION_CAPACITY_MODULE_EVIDENCE_CONTRACT,
  [PORTFOLIO_CAPACITY_ALLOCATION_MODULE_EVIDENCE_CONTRACT.moduleId]:
    PORTFOLIO_CAPACITY_ALLOCATION_MODULE_EVIDENCE_CONTRACT,
  [ORG_ANALYSIS_OPTIMIZATION_MODULE_EVIDENCE_CONTRACT.moduleId]:
    ORG_ANALYSIS_OPTIMIZATION_MODULE_EVIDENCE_CONTRACT,
  [ORG_PATTERN_COST_MODULE_EVIDENCE_CONTRACT.moduleId]:
    ORG_PATTERN_COST_MODULE_EVIDENCE_CONTRACT,
  [OUTSIDE_CONTRACTORS_MODULE_EVIDENCE_CONTRACT.moduleId]:
    OUTSIDE_CONTRACTORS_MODULE_EVIDENCE_CONTRACT,
  [LABOR_ARBITRAGE_MODULE_EVIDENCE_CONTRACT.moduleId]: LABOR_ARBITRAGE_MODULE_EVIDENCE_CONTRACT,
  [PRODUCTIVITY_LEAN_AI_MODULE_EVIDENCE_CONTRACT.moduleId]:
    PRODUCTIVITY_LEAN_AI_MODULE_EVIDENCE_CONTRACT,
  // #4449 batch 1 (2026-08-08): five modules whose APPROVED, ingest-anchored
  // artifacts the readiness matrix read as CONTRACT_ABSENT because nothing
  // registered their evidence identity. Each contract's contextKind/schemaVersion
  // pair is the module engine's own query literal, verified against a live
  // read-only census on tenant helix_retail. Keys that do NOT resolve through an
  // AskHelixMemoryArtifact contextKind are deliberately left unregistered — see
  // each contract's SCOPE NOTE.
  [FINANCE_MODULE_EVIDENCE_CONTRACT.moduleId]: FINANCE_MODULE_EVIDENCE_CONTRACT,
  [CARRIER_TRANSPORTATION_COST_MODULE_EVIDENCE_CONTRACT.moduleId]:
    CARRIER_TRANSPORTATION_COST_MODULE_EVIDENCE_CONTRACT,
  [RISK_CLAIMS_MODULE_EVIDENCE_CONTRACT.moduleId]: RISK_CLAIMS_MODULE_EVIDENCE_CONTRACT,
  [PRICING_REALIZATION_MODULE_EVIDENCE_CONTRACT.moduleId]:
    PRICING_REALIZATION_MODULE_EVIDENCE_CONTRACT,
  [COST_TO_SERVE_MODULE_EVIDENCE_CONTRACT.moduleId]: COST_TO_SERVE_MODULE_EVIDENCE_CONTRACT,
  // #4449 batch 2 (2026-08-08). capital-allocation is deliberately absent: its
  // engine literals exist, but a live read-only census found ZERO APPROVED
  // ingest-anchored rows under them, and a contract must attest to data that is
  // actually present. It stays unwritten with a named line in the lane receipt.
  [ESG_EMISSIONS_MODULE_EVIDENCE_CONTRACT.moduleId]: ESG_EMISSIONS_MODULE_EVIDENCE_CONTRACT,
  [CHURN_REDUCTION_MODULE_EVIDENCE_CONTRACT.moduleId]: CHURN_REDUCTION_MODULE_EVIDENCE_CONTRACT,
  [COMMERCIAL_EFFECTIVENESS_MODULE_EVIDENCE_CONTRACT.moduleId]:
    COMMERCIAL_EFFECTIVENESS_MODULE_EVIDENCE_CONTRACT,
  [SEGMENT_MARGIN_CLEANUP_MODULE_EVIDENCE_CONTRACT.moduleId]:
    SEGMENT_MARGIN_CLEANUP_MODULE_EVIDENCE_CONTRACT,
  // #4449 batch 3 (2026-08-09) — the single-snapshot lever modules, all four
  // structurally identical and declared through one shared factory. See
  // leverSnapshotModuleEvidenceContracts.ts for the live census and the
  // deliberately-stricter cadence.
  [CAPACITY_UTILIZATION_MODULE_EVIDENCE_CONTRACT.moduleId]:
    CAPACITY_UTILIZATION_MODULE_EVIDENCE_CONTRACT,
  [FUEL_EFFICIENCY_MODULE_EVIDENCE_CONTRACT.moduleId]: FUEL_EFFICIENCY_MODULE_EVIDENCE_CONTRACT,
  [MARKETING_SPEND_MODULE_EVIDENCE_CONTRACT.moduleId]: MARKETING_SPEND_MODULE_EVIDENCE_CONTRACT,
  [NETWORK_OPTIMIZATION_MODULE_EVIDENCE_CONTRACT.moduleId]:
    NETWORK_OPTIMIZATION_MODULE_EVIDENCE_CONTRACT,
  // K3 batch (2026-08-18, amended per Codex review 5324455668):
  // workforce-reduction registers with EMPTY artifact entries — its six
  // manifest-required keys are typed non-artifact classifications naming
  // their real run-data authorities (the evidence pack is optional
  // augmentation, not the substrate). ma-synergy-tracking's contextKind/
  // schemaVersion are imported from lib's own ma-synergy-commitment.ts.
  [WORKFORCE_REDUCTION_MODULE_EVIDENCE_CONTRACT.moduleId]:
    WORKFORCE_REDUCTION_MODULE_EVIDENCE_CONTRACT,
  [MA_FUSION_SYNERGY_MODULE_EVIDENCE_CONTRACT.moduleId]:
    MA_FUSION_SYNERGY_MODULE_EVIDENCE_CONTRACT,
} as const;

type ModuleEvidenceContractRegistry = Readonly<
  Record<keyof typeof moduleEvidenceContractRegistryEntries, ModuleEvidenceContract>
>;

export const MODULE_EVIDENCE_CONTRACT_REGISTRY: ModuleEvidenceContractRegistry =
  Object.freeze(moduleEvidenceContractRegistryEntries);

export type RegisteredModuleEvidenceContractId = keyof typeof MODULE_EVIDENCE_CONTRACT_REGISTRY;
